module.exports = __webpack_public_path__ + "static/img/subtitle.66984268.png";